import { SubscriptionModel, SubscriptionsModel } from 'src/models/SubscriptionModel';
import { Reducer } from 'redux';
import { RESET_SUBSCRIPTION, UPDATE_SUBSCRIPTION } from 'src/redux/actions/subscriptionActions';

export type SubscriptionsState = SubscriptionsModel;

const DEFAULT = {} as SubscriptionsState;

const subscriptionReducer: Reducer<SubscriptionsState> = (state = DEFAULT, action) => {
  switch (action.type) {
    case UPDATE_SUBSCRIPTION: {
      const { id, subscription } = action.payload;
      return { ...state, [id]: { ...subscription as SubscriptionModel } };
    }
    case RESET_SUBSCRIPTION: {
      const { subscriptionId } = action.payload;
      const { [subscriptionId]: removedSubscription, ...remainingSubscriptions } = state;
      return { ...remainingSubscriptions };
    }
    default:
      return state;
  }
};

export default subscriptionReducer;
